import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Transaction } from "../../api/services";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@material-ui/core";
import { APIError } from "../../components/APIError";

import { TransactionRow } from "./components/TransactionRow";
import { useAccountTransactions } from "./hooks/useAccountTransactions";
import {
  CustomPaginatedTableContainer,
  ColumnHead,
  LoadingRow,
} from "../../components/CustomTableComponents";

export const Transactions: React.FC = () => {
  const { accountNumber } = useParams();
  const {
    page,
    pageSize,
    setPage,
    count,
    data: transactions,
    status,
    error,
  } = useAccountTransactions(accountNumber);

  return (
    <>
      <Helmet>
        <title>{accountNumber} - Account Financials: Transactions</title>
      </Helmet>
      {error ? (
        <APIError title="We could not load transactions for this account." />
      ) : (
        <CustomPaginatedTableContainer
          maxWidth="1280px"
          width="100%"
          paginationProps={{
            page,
            pageSize,
            count,
            setPage,
          }}
        >
          <Table>
            <TableHead data-testid="Transactions__TableHead">
              <TableRow>
                <ColumnHead boxProps={{ width: "128px" }}>Date</ColumnHead>
                <ColumnHead boxProps={{ width: "128px" }}>Type</ColumnHead>
                <ColumnHead>Summary</ColumnHead>
                <ColumnHead boxProps={{ width: "128px", textAlign: "right" }}>
                  Debit
                </ColumnHead>
                <ColumnHead boxProps={{ width: "128px", textAlign: "right" }}>
                  Credit
                </ColumnHead>
                <ColumnHead boxProps={{ width: "150px", textAlign: "right" }}>
                  Account Balance
                </ColumnHead>
                <ColumnHead boxProps={{ width: "150px" }}>Actions</ColumnHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {status === "loading" ? (
                <LoadingRow col={7} />
              ) : transactions && transactions.length > 0 ? (
                transactions!.map((transaction: Transaction) => (
                  <TransactionRow
                    transaction={transaction}
                    key={transaction.id}
                  />
                ))
              ) : (
                transactions && (
                  <TableRow>
                    <TableCell colSpan={7}>
                      No transactions for this account.
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </CustomPaginatedTableContainer>
      )}
    </>
  );
};
